import routerOptions0 from "/app/src/app/router.options.ts";
import routerOptions1 from "/app/node_modules/.pnpm/nuxt@3.3.3_@types+node@18.19.130_db0@0.3.4_ioredis@5.10.1_magicast@0.5.3_rollup@4.60.4_sass@1_tn2gqs4gx373jt2wpoo3hg7puq/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false
}
export default {
...configRouterOptions,
...routerOptions1,
...routerOptions0,
}